// extracted by mini-css-extract-plugin
export default {"button":"Button_button__cSyba","primary":"Button_primary__RiQsd","tertiary":"Button_tertiary__3grDa","row":"Button_row__1ASLp"};